import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@material-ui/core";

const SelectedDisplayValue = ({ text, showAsterisk = false }) => {
  const theme = useTheme();

  return (
    <>
      {showAsterisk && <span style={{ color: theme.palette.primary.red }}>{"* "}</span>}
      {text}
    </>
  );
};

SelectedDisplayValue.propTypes = {
  text: PropTypes.string.isRequired,
  showAsterisk: PropTypes.bool,
};

SelectedDisplayValue.defaultProps = {
  showAsterisk: false,
};

export default SelectedDisplayValue;
